import React, { Fragment, RefObject } from 'react';
import { animated, SpringValue } from '@react-spring/web';

type TProps = {
  clipId: string;
  imageUrl: string;
  imageRef: RefObject<SVGImageElement>;
  imageSpringValues: {
    x: SpringValue<number>;
    y: SpringValue<number>;
    height: SpringValue<number>;
    width: SpringValue<number>;
  };
  frameSpringValues: {
    x: SpringValue<number>;
    y: SpringValue<number>;
    height: SpringValue<number>;
    width: SpringValue<number>;
  };
};

function ClippedPreviewImage({
  clipId,
  imageUrl,
  imageRef,
  imageSpringValues,
  frameSpringValues
}: TProps): React.ReactElement {
  return (
    <Fragment>
      <defs key="defs">
        <clipPath id={`clip-${clipId}`}>
          <animated.rect
            x={0}
            y={0}
            height={frameSpringValues.height}
            width={frameSpringValues.width}
          />
        </clipPath>
      </defs>
      <animated.image
        x={imageSpringValues.x}
        y={imageSpringValues.y}
        height={imageSpringValues.height}
        width={imageSpringValues.width}
        href={imageUrl}
        clipPath={`url(#clip-${clipId})`}
        ref={imageRef}
        key="image"
        touch-action="none"
      />
    </Fragment>
  );
}

export default ClippedPreviewImage;
